import(/* webpackMode: "eager" */ "/codebuild/output/src2685805791/src/app/home/page.tsx");
